module.exports = __webpack_public_path__ + "img/us.c09801e2.svg";